import React, {useEffect, useState} from 'react';
import Axios from 'axios';
import { Modal } from 'react-bootstrap';
import '../App.css';
import Pagination from '../components/global/Paginator'
import {formatDate} from "../utils/dates";

function Grillacltickest (props){
    const [datos, setDatos] = useState([]);
    const [datosBackup, setDatosBackup] = useState([])
    const [fechainicio, setFechaInicio] = useState('')
    const [fechafinal, setFechaFinal] = useState('')
    const [pageSize, setPageSize] = useState(3);
    const [pageNumber, setPageNumber] = useState('')
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);   
    let statuscall = '' 
    
    const dataList = Array.isArray(datos) && datos.length > 0
    ? datos.map((item, i) => (
    <tr key={i} class="divide-y divide-gray-100 bg-white">
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.beneficiario_fullname}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.fecha_pago}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.fecha_consumo}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.estado_consumo}</td>
        <td class="px-6 py-4 whitespace-nowrap text-sm">{item.estado_pago}</td>
    </tr>
    )):(
      // opcional: fila vacía o mensaje cuando no hay datos
      <tr>
        <td className="px-6 py-4 text-sm text-gray-500" colSpan={7}>
          Sin resultados
        </td>
      </tr>
    );

    useEffect(() => {

        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idcasinostr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        
        let mail = mailstr.replace('"', '')
        let idperfil = idperfilstr.replace('"', '')
        let idcasino = idcasinostr.replace('"', '')        

        Axios.get(process.env.REACT_APP_DATAUSER, {
            params: {
                mail: mail,
                id_perfil: idperfil,
                id_casino: idcasino,
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.ticket_detail)
            setDatosBackup(response.data.ticket_detail)

            setCurrentPage(response.data.ticket_detail_metadata.currentPage)
            setPageNumber(response.data.ticket_detail_metadata.currentPage)
            setTotalPages(response.data.ticket_detail_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }, []);


    const handleChangeList= (e) => {
        let text = e.target.value;
        const setBusqueda = e.target.value;
        console.log("Busqueda: " + e.target.value)
        const data = datosBackup
        const newData = data.filter(
            function(item){
                const itemDataNombre = item.beneficiario_fullname
                const itemDatafecha_pago = item.fecha_pago
                const itemDatafecha_consumo = item.fecha_consumo
                const itemDataestado_consumo = item.estado_consumo.toUpperCase()
                const itemDataestado_pago = item.estado_pago.toUpperCase()
                const campo = itemDataNombre +" "+ itemDatafecha_pago +" "+ itemDatafecha_consumo +" "+ itemDataestado_consumo +" "+ itemDataestado_pago
                const textData = text.toUpperCase()
                return campo.indexOf(textData) > -1      
            }
        )
        setDatos(newData)
        console.log(newData)
        console.log(datos)
    }

    const handleFechaInicio = (e) => {
        setFechaInicio(e.target.value)
    }

    const handleFechaFinal = (e) => {
        setFechaFinal(e.target.value)
    }
    
    const handlePageSize = (e) => {
        setPageSize(e.target.value)
    }

    const GetTicket = () =>
    {
        const date = new Date();

        // Formateamos la fecha en formato yyyy-mm-dd
        const formattedDate = date.toISOString().split('T')[0];

        let mailstr = window.localStorage.getItem('MY_APP_STATE_USER').replace('"', '')
        let idperfilstr = window.localStorage.getItem('MY_APP_STATE_PROF_ID').replace('"', '')
        let idcasinostr = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
        
        let mail = mailstr.replace('"', '')
        let idperfil = idperfilstr.replace('"', '')
        let idcasino = idcasinostr.replace('"', '')        

        Axios.get(process.env.REACT_APP_URLTICKETDETAILLISTAR, {
            params: {
                mail: mail,          
                page: pageNumber || 1,
                pageSize: pageSize || 10,
                fecha_inicio: fechainicio || formattedDate,
                fecha_fin: fechafinal || formattedDate
            }, 
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }
        }).then((response) => {
            setDatos(response.data.ticket_detail)
            setDatosBackup(response.data.ticket_detail)            

            setCurrentPage(response.data.ticket_detail_metadata.currentPage)
            setPageNumber(response.data.ticket_detail_metadata.currentPage)
            setTotalPages(response.data.ticket_detail_metadata.totalPages)
        }).catch(error => {
            return error     
        });
    }

    return(
    <div className='w-full'>
        {/* Zona 1 - Filtros */}
        <div className="bg-white shadow-lg p-6  mx-4 mb-2">
            {/* Zona 1 - Header con Título y Filtros */}
            <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-4">
            <h1 class="text-2xl font-bold">Detalle Tickets</h1>

            <div class="flex flex-wrap gap-4">
                
                {/* Campo Fecha Inicio */}
                <div className="flex flex-col">
                    <input
                    placeholder='Fecha Inicio'
                    value={fechainicio} 
                    onChange={handleFechaInicio} 
                    type="date" 
                    id="fechaInicio" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Fecha Fin */}
                <div className="flex flex-col">
                    <input
                    placeholder='Fecha Fin'
                    value={fechafinal} 
                    onChange={handleFechaFinal}  
                    type="date" 
                    id="fechaFin" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/* Campo Selección Número de Páginas */}
                <div className="flex flex-col">
                    <input 
                    placeholder='Registros por página'
                    type="number" 
                    id="numeroPaginas"
                    value={pageSize}
                    onChange={handlePageSize} 
                    min="1" 
                    step="1" 
                    defaultValue="1" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500" 
                    />
                </div>

                {/*Buscador*/}
                <div class="relative">
                <input type="text" 
                    placeholder="Buscar en grilla" 
                    class="border border-gray-300 rounded-lg pl-10 pr-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    id="Buscar en grilla"
                    onChange={handleChangeList} />
                <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35m1.4-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                    </svg>
                </div>
                </div>

                {/* Botón generar reporte */}
                <button
                    onClick={GetTicket}
                    className="flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow"
                    >
                    <svg
                        className="w-4 h-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 4H7a2 2 0 01-2-2V6a2 2 0 012-2h7l5 5v11a2 2 0 01-2 2z"
                        />
                    </svg>
                    <span>Generar Reporte</span>
                </button>

                {/*Botón Exportar a Excel*/}
                {/*<button onClick={handleExport} class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white text-sm font-medium px-4 py-2 rounded-lg shadow">
                <svg class="w-4 h-4 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path d="M384 121.9V128H272V0H128C92.7 0 64 28.7 64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h64v-38.1c0-13.1-10.6-23.9-23.7-23.9H384zM299.1 272l-42.1 48 42.1 48H258l-26.5-31.1L205 368h-40.5l42.1-48-42.1-48H205l26.5 31.1L258 272h41.1z"/>
                </svg>
                <span>Export</span>
                <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4" />
                </svg>
                </button>*/}

            </div>            
        </div>

        {/* Zona 2 */}
        <div className="bg-white shadow-lg p-4 mx-4 mb-2">
            {/* Zona 2 */}
            <div className="bg-white shadow-lg p-4 mx-4 mb-2">
                {/* Controles de Búsqueda y Exportar */}
                <div className="overflow-y-auto h-[600px] p-4">
                    {/* Contenedor para los detalles de los tickets */}
                    <div className="space-y-6">
                        <div class="bg-white shadow rounded-2xl overflow-hidden">
                            <div class="max-h-96 overflow-y-auto">
                                <table class="min-w-full table-auto">
                                <thead class="bg-gray-50 sticky top-0 z-10">
                                    <tr>
                                        <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Nombre Alumno</th>
                                        <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Fecha Pago</th>
                                        <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Fecha Consumo</th>
                                        <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Estado Pago</th>
                                        <th class="px-6 py-4 text-left text-sm font-semibold text-gray-600 bg-gray-50">Estado Consumo</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-100 bg-white">
                                    {dataList}
                                </tbody>
                                </table>
                            </div>

                            {/*Paginación*/} 
                            <div class="flex items-center justify-between mt-6">
                                <div class="inline-flex items-center space-x-2">
                                <Pagination currentPage={pageNumber} totalPages={totalPages} onPageChange={setPageNumber}/>            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>      
        </div>
    </div> 
    </div>   
    )
}
export default Grillacltickest